import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

const TrendMovieSkeletion = () => {
  const arr = [1, 2, 3, 4, 5, 6];
  return (
    <div className="mt-20">
      <div className="flex flex-row justify-between">
        <div className="w-[250px] h-[30px] bg-[#1a1919] rounded-lg"></div>
        <div className="w-[100px] h-[30px] mr-[50px] bg-[#1a1919] rounded-lg"></div>
      </div>
      <div className="">
        <Swiper
          slidesPerView={6}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            370: {
              slidesPerView: 2,
            },
            700: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 5,
            },
            1400: {
              slidesPerView: 6,
            },
            1600: {
              slidesPerView: 7,
            },
          }}
          className="mt-4 mb-5 mySwiper ml-5"
        >
          <div className="flex flex-row lg:gap-[40px] sm:gap-[20px] gap-3 mt-10 ">
            {arr.map((item: any) => (
              <div
                key={item}
                className="flex flex-col justify-center items-start"
              >
                <div className="lg:w-[180px] h-[330px] bg-[#1a1919] animate-pulse mt-2 rounded-lg"></div>
                <div className="lg:w-[180px] h-[20px] bg-[#1a1919] animate-pulse mt-5  rounded-lg"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default TrendMovieSkeletion;
